<div class="ir-area ir-mask th-mask">
  <form class="ir-modal th-modal" novalidate="" [formGroup]="editForm" (ngSubmit)="save(editForm.value)">
    <modal-header [plugin]="plugin" [menuModal]="menuModal"></modal-header>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content th-content-customer">
        <h2>
          <span>{{ 'plugins.installationlubricant.header' | translate }} :</span>
        </h2>
        <div formArrayName="lubricants" *ngFor="let item of formData.controls; let i = index">
          <table class="ir-modal-table">
            <tr>
              <td></td>
              <td class="th-plugin-line--remove th-plugin-line--remove-customer" colspan="2" align="right">
                <i class="material-icons" (click)="openItemDeleteConfirm(i)">remove_circle</i>
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span style="margin-left: 10px">{{ 'plugins.installationlubricant.brand' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" [formGroupName]="i">
                <input name="Brand" class="ir-form-set" formControlName="Brand" />
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span style="margin-left: 10px">{{ 'plugins.installationlubricant.type' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" [formGroupName]="i">
                <input name="Type" class="ir-form-set" formControlName="Type" />
              </td>
            </tr>
            <tr>
              <td class="margin-big">
                <h2>
                  <span style="margin-left: 10px">{{ 'plugins.installationlubricant.viscosity' | translate }}</span>
                </h2>
              </td>
              <td class="margin-big" [formGroupName]="i">
                <input name="Viscosity" class="ir-form-set" formControlName="Viscosity" />
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="ir-content--modal th-content th-content-plus">
        <table class="ir-modal-table">
          <tr class="th-plugin-line--add th-plugin-line--add-customer">
            <td colspan="4">
              <i class="material-icons" (click)="add()">add_circle</i>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <modal-footer [editForm]="editForm" [processing]="processing"></modal-footer>
  </form>
</div>
<modal #menuModal (modalOutput)="selectMenu($event)"></modal>
<confirm
  #itemDeleteConfirm
  (confirmOutput)="remove($event)"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.installationlubricant.sure-to-delete' | translate"
  [danger]="true"
></confirm>
<confirm
  #pluginDeleteConfirm
  (confirmOutput)="deletePlugin()"
  [title]="'common.delete-confirmation' | translate"
  [message]="'plugins.sure-to-delete' | translate"
  [danger]="true"
></confirm>
